import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { map, take, switchMap, of, catchError } from 'rxjs';
import { OrganizationModuleEnum } from '../models/organization-module.enum';

/**
 * Blocks a route unless the current user's organization has the module named in
 * route data enabled, e.g. `data: { module: OrganizationModuleEnum.SPEECH_ANALYSIS }`.
 * Mirrors authGuard's shape (ensures currentUser$ is loaded before checking).
 */
export const moduleGuard = (route: ActivatedRouteSnapshot) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const requiredModule = route.data['module'] as OrganizationModuleEnum | undefined;

    if (!requiredModule) {
        return of(true);
    }

    return authService.currentUser$.pipe(
        take(1),
        switchMap(user => {
            if (user) {
                return of(user);
            }
            return authService.fetchCurrentUser().pipe(catchError(() => of(null)));
        }),
        map(user => {
            if (user?.modules?.includes(requiredModule)) {
                return true;
            }
            router.navigate(['/dashboard']);
            return false;
        })
    );
};
